module.exports = __webpack_public_path__ + "img/Double Rich Slots.4460e3c0.png";